import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/built-for-developers')({
  beforeLoad: () => {
    throw redirect({ to: '/technology' });
  },
  component: () => null,
});
